import { Spin } from 'antd';
import type React from 'react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface OrganizationGuardProps {
  children: React.ReactNode;
}

const OrganizationGuard: React.FC<OrganizationGuardProps> = ({ children }) => {
  const { user, updateUser } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [hasOrganization, setHasOrganization] = useState(false);

  useEffect(() => {
    const checkUserOrganizations = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      // If user already has organizationId, they're part of an organization
      if (user.organizationId) {
        setHasOrganization(true);
        setLoading(false);
        return;
      }

      // For now, if no organizationId, assume they need onboarding
      // TODO: This should check our backend API once it's properly connected
      setHasOrganization(false);
      setLoading(false);
    };

    checkUserOrganizations();
  }, [user, updateUser]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'transparent',
          gap: '16px',
        }}
      >
        <Spin size="large" />
        <div style={{ color: '#666', fontSize: '14px' }}>Checking organization status...</div>
      </div>
    );
  }

  if (!hasOrganization) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};

export default OrganizationGuard;
